import { render, staticRenderFns } from "./FormRepliesList.vue?vue&type=template&id=19d47dd8&"
import script from "./FormRepliesList.vue?vue&type=script&lang=ts&"
export * from "./FormRepliesList.vue?vue&type=script&lang=ts&"
import style0 from "./FormRepliesList.vue?vue&type=style&index=0&id=19d47dd8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports